import React from "react";
import PropTypes from "prop-types";
import { StyledCmeButton } from "./_.styled";

const CmeButton = ({ onClick, size, label, counterValue }) => {
  const buttonText = (
    <>
      {label} {!!counterValue && <span>&nbsp;{counterValue}</span>}
    </>
  );

  return (
    <StyledCmeButton size={size} onClick={onClick}>
      {buttonText}
    </StyledCmeButton>
  );
};

CmeButton.propTypes = {
  onClick: PropTypes.func.isRequired,
  size: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  counterValue: PropTypes.number,
};

export default CmeButton;
